<ng-container *ngIf="data">
  <ng-container *ngIf="data.link; else cardTemplate">
    <ng-container [ngSwitch]="data.link.type">
      <a *ngSwitchCase="linkTypes.ROUTER" class="card-container" [routerLink]="data.link.url">
        <ng-container *ngTemplateOutlet="cardTemplate"></ng-container>
      </a>
      <a *ngSwitchCase="linkTypes.PROGRAMMATIC" class="card-container" (click)="linkAction($event)">
        <ng-container *ngTemplateOutlet="cardTemplate"></ng-container>
      </a>
      <a *ngSwitchCase="linkTypes.EXTERNAL" class="card-container" [href]="data.link.url" [target]="data.link.target">
        <ng-container *ngTemplateOutlet="cardTemplate"></ng-container>
      </a>
      <div *ngSwitchCase="linkTypes.NONE" class="card-container">
        <ng-container *ngTemplateOutlet="cardTemplate"></ng-container>
      </div>
    </ng-container>
  </ng-container>

  <ng-template #cardTemplate>
    <ng-container [ngSwitch]="layout">
      <mb-card-hero
        *ngSwitchCase="cardLayout.HERO"
        [data]="data"
        [alignContent]="alignContent"
        [fuelLabelPosition]="fuelLabelPosition"
      >
        <ng-container media>
          <ng-container *ngTemplateOutlet="mediaTpl"></ng-container>
          <span class="press-kit-flag hero-flag copy-s" *ngIf="data.type === pressKitCardType">
            {{ 'PRESS_KIT' | translate }}
          </span>
        </ng-container>
        <ng-container action-container *ngTemplateOutlet="actionContainerTpl"></ng-container>
      </mb-card-hero>

      <mb-card-row
        *ngSwitchCase="cardLayout.ROW"
        [data]="data"
        [alignContent]="alignContent"
        [fuelLabelPosition]="fuelLabelPosition"
      >
        <ng-container media>
          <ng-container *ngTemplateOutlet="mediaTpl"></ng-container>
          <span class="press-kit-flag row-flag copy-s" *ngIf="data.type === pressKitCardType">
            {{ 'PRESS_KIT' | translate }}
          </span>
        </ng-container>
        <ng-container action-container *ngTemplateOutlet="actionContainerTpl"></ng-container>
      </mb-card-row>

      <mb-card-column
        *ngSwitchCase="cardLayout.COLUMN"
        [data]="data"
        [alignContent]="alignContent"
        [fuelLabelPosition]="fuelLabelPosition"
      >
        <ng-container media>
          <ng-container *ngTemplateOutlet="mediaTpl"></ng-container>
          <span class="press-kit-flag copy-s" *ngIf="data.type === pressKitCardType">
            {{ 'PRESS_KIT' | translate }}
          </span>
        </ng-container>
        <ng-container action-container *ngTemplateOutlet="actionContainerTpl"></ng-container>
      </mb-card-column>
    </ng-container>
  </ng-template>

  <ng-template #mediaTpl>
    <ng-content select="figure"></ng-content>
  </ng-template>
</ng-container>

<ng-template #actionContainerTpl>
  <mb-action-container
    *ngIf="actions && actions.length"
    [buttonItems]="actions"
    [resource]="data"
    (actionClick)="actionClick.emit($event)"
  ></mb-action-container>
</ng-template>
